import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-5da6d35f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: { display: 'flex', justifyContent: 'end', margin: '20px' } }
const _hoisted_2 = { class: "styleDiv" }
const _hoisted_3 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "simple-spinner" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Vue logo",
  class: "image"
}, null, -1))
const _hoisted_8 = { style: { display: 'flex', justifyContent: 'center ' } }
const _hoisted_9 = { class: "deleteImage" }
const _hoisted_10 = { style: {"text-align":"center","margin":"10px 0 5px 0","font-size":"20px","color":"#522537","font-weight":"600","letter-spacing":"0.5px","font-family":"sans-serif"} }
const _hoisted_11 = { style: {"text-align":"center","margin":"10px 0 15px 0","font-size":"15px","color":"gray","height":"80px","display":"flex","align-items":"center"} }
const _hoisted_12 = { style: {"text-align":"center","margin":"10px 0 25px 0","font-size":"15px","color":"gray"} }
const _hoisted_13 = { style: {"text-align":"center","margin":"10px 0 20px 0","font-size":"15px","color":"gray"} }
const _hoisted_14 = { class: "flexDisplay mrgb" }
const _hoisted_15 = {
  class: "ant-form-text",
  type: "secondary"
}
const _hoisted_16 = { class: "center" }

import { DeleteFilled, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
import { createVNode, onMounted, ref } from "vue";
import { deletedUserApi } from "@/services/api/auth";
import { openNotificationWithIcon } from "@/utils";
import router from "@/router";
import LanguageDropdown from "@/components/LanguageDropdown.vue";

// local state

export default /*#__PURE__*/_defineComponent({
  __name: 'deleteAccount',
  setup(__props) {

const identifier = ref("");
const userId = ref("");
const loading = ref(false);

// translations state
const language = ref(localStorage.getItem("lang_for_delete") || "EN");
const translate = ref<any[]>([]);
const languageList = ref<any[]>([]);

const initTranslations = (stored: any) => {
	translate.value = stored?.deletePageTranslations || [];
	languageList.value = stored?.languageList || [];
};

const t = (key: string, params: Record<string, string> = {}): string => {
	const item = translate.value.find(i => i.key === key);
	if (!item) return key;
	const selectedLang = languageList.value.find(l => l.key === language.value);
	const langId = selectedLang?._id;
	let value = item.translate.find((t: any) => t.languageId === langId && t.isPublished)?.value;
	if (!value) {
		const enLang = languageList.value.find(l => l.key.toLowerCase() === "en");
		const enId = enLang?._id;
		value = item.translate.find((t: any) => t.languageId === enId && t.isPublished)?.value;
	}
	if (!value) value = item.base;
	return value;
};

const setLanguage = (lang: string) => {
	language.value = lang;
	localStorage.setItem("lang_for_delete", lang);
};

const handleLanguageChange = (lang: string) => {
	setLanguage(lang);
};

// data fetch
const fetchData = async () => {
	loading.value = true;
	const userData = localStorage.getItem("user");
	const languages = localStorage.getItem("delete_page_translate");

	if (languages) {
		const parsedLanguage = JSON.parse(languages || "{}");
		initTranslations(parsedLanguage); // <-- hydrate
	}

	if (!userData) {
		router.push("/login");
		loading.value = false;
		return;
	}

	if (userData && typeof userData === "string") {
		const user = JSON.parse(userData);
		identifier.value = user.identifier || "";
		userId.value = user._id || "";
	}

	loading.value = false;
};
onMounted(fetchData);

// delete handling
const handleDelete = () => {
	Modal.confirm({
		centered: true,
		width: 500,
		title: t("del_ui_del_model_info"),
		icon: createVNode(ExclamationCircleOutlined),
		okText: t("del_ui_del_model_del_btn"),
		okType: "danger",
		cancelText: t("del_ui_del_btn_cancel"),
		async onOk() {
			try {
				const userData = localStorage.getItem("user");
				if (userData) {
					const user = JSON.parse(userData);
					const deleteUser = await deletedUserApi(user._id, "deleteUser");
					if (deleteUser) {
						localStorage.removeItem("user");
						return openNotificationWithIcon("success", t("del_ui_account_delete_msg"));
					}
				}
			} catch (error: any) {
				if (!error.response && error.message === "Network Error") {
					return openNotificationWithIcon("error", t("del_ui_network_error"));
				}
				if (error?.response?.status === 404) {
					return openNotificationWithIcon("error", t("del_ui_user_not_exist"));
				} else {
					return openNotificationWithIcon("error", t("del_ui_support_team_msg"));
				}
			} finally {
				router.push("/login");
			}
		},
	});
};

const handleCancel = () => {
	router.push("/login");
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LanguageDropdown, {
        languageList: languageList.value,
        defaultLang: language.value,
        onLanguageChanged: handleLanguageChange
      }, null, 8, ["languageList", "defaultLang"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_a_form, { class: "form" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(DeleteFilled), { style: {"font-size":"2.5em","color":"#522537"} })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(t('del_ui_del_page_heading')), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(t('del_ui_del_page_intro_1')), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("b", null, _toDisplayString(t('del_ui_del_page_intro_2')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(t('del_ui_del_page_intro_3')), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(identifier.value), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_button, {
                    size: "large",
                    class: "btn",
                    onClick: handleCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(t('del_ui_del_btn_cancel')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    size: "large",
                    class: "btn",
                    onClick: handleDelete
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(t('del_ui_del_btn_delete_account')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]))
    ])
  ], 64))
}
}

})